import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBabelComponent } from './simple-icons-babel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBabelComponent ],
    exports:      [ SimpleIconsBabelComponent ],
    bootstrap:    []
})
export class SimpleIconsBabelModule {}
